import React from "react";

export const STATUS_LABELS = {
    aperto: "Aperto",
    in_lavorazione: "In lavorazione",
    in_attesa: "In attesa",
    chiuso: "Chiuso",
};

export function StatusChip({ status }) {
    const label = STATUS_LABELS[status] || status;
    return (
        <span className={`lt-chip-status lt-chip-${status}`} data-testid={`status-chip-${status}`}>
            <span className="dot" />{label}
        </span>
    );
}

export function fmtDateTime(iso) {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
    } catch { return "—"; }
}
